import api from "./api";

export const getInvoices = (page, size) => {
  return api.get(`/invoices?page=${page}&size=${size}`);
};

export const getInvoiceById = (id) => {
  return api.get(`/invoices/${id}`);
};

export const createInvoice = (data) => {
  return api.post("/invoices", data);
};

export const createInvoiceFromOrder = (orderReference, defaultTaxRate) => {
  const params = defaultTaxRate != null ? { defaultTaxRate } : {};
  return api.post(`/invoices/from-order/${orderReference}`, null, { params });
};

export const updateInvoice = (id, data) => {
  return api.put(`/invoices/${id}`, data);
};

export const updateInvoiceStatus = (id, status, paymentMethod) => {
  const data = { status };
  if (paymentMethod) {
    data.paymentMethod = paymentMethod;
  }
  return api.put(`/invoices/${id}/status`, data);
};

export const deleteInvoice = (id) => {
  return api.delete(`/invoices/${id}`);
};

export const getInvoicesByCustomer = (customerId, page, size) => {
  return api.get(`/invoices/by-customer/${customerId}?page=${page}&size=${size}`);
};

export const getInvoicesByOrder = (orderId) => {
  return api.get(`/invoices/by-order/${orderId}`);
};

export const getInvoiceStatistics = () => {
  return api.get("/invoices/statistics");
};

export const getOverdueInvoices = (page, size) => {
  return api.get(`/invoices/overdue?page=${page}&size=${size}`);
};

export const downloadInvoicePdf = (id) => {
  return api.get(`/invoices/${id}/pdf`, { responseType: "blob" });
};

// E-Fatura endpoints
export const sendEInvoice = (id) => {
  return api.post(`/invoices/${id}/send-einvoice`);
};

export const checkEInvoiceStatus = (id) => {
  return api.get(`/invoices/${id}/einvoice-status`);
};

export const cancelEInvoice = (id) => {
  return api.post(`/invoices/${id}/cancel-einvoice`);
};
